import React from "react";
import { CommandsTemplate } from "./CommandsTemplate";
import { ParamsTemplate } from "./CommandsParams";
import { Box, Grid, IconButton, Slide, Slider } from "@mui/material";
import { CommandContextStore } from "../context/CommandContext";
import { Navigate } from "react-router-dom";
import { Tune } from "@mui/icons-material";

export const CommandsMain = () => {
  const commandContext = React.useContext(CommandContextStore);
  const [showParams, setShowParams] = React.useState(true)

  React.useEffect(() => {
    
  }, []);

  return (
    <>
      {commandContext.hasError && <Navigate to="/toolerror"/>}
      {!commandContext.hasError &&
      <>
      <div style={{display:"flex", justifyContent:"space-between"}}>
        <Box sx={{width: 100}}>
        <Slider aria-label="Volume" />
        </Box>
        <IconButton onClick={()=>{setShowParams(!showParams)}}>
          <Tune />
        </IconButton>
      </div>
      <Grid container alignItems="stretch" spacing={1}>
        <Grid item xs={showParams? 9: 12} >
          <CommandsTemplate />
        </Grid>
        <Slide direction="left" in={showParams} mountOnEnter unmountOnExit>
          <Grid item xs={3} >
            <ParamsTemplate />
          </Grid>
        </Slide>

      </Grid>
      </>
      }
    </>
  );
};
